/* istanbul ignore file */
import React from 'react';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import useResumeService from 'domain/recruiting/candidate/Timeline/resume/resumeService';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import ResumeForm from 'domain/recruiting/candidate/Timeline/resume/form/ResumeForm';

interface UpdateResumeFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  service: () => any;
  onCancel: () => void;
}

const UpdateResumeForm = ({ getDataFunc, onCancel, ...props }: UpdateResumeFormProps) => {
  const { getValidationSchema, update } = useResumeService();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <ResumeForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateResumeForm;
